import { GroupedBarChart } from "components/charts";
import { useMonthlyUsageChart } from "pages/UsagePage/compositions/MonthlyUsageChartProvider";
import React from "react";
import { ERROR_BOUNDARY_MESSAGES } from "utils/constants";

import {
  generateGroupedBarChartConfig,
  getMaxYValue,
  MonthlyData,
} from "./MonthlyUsageChart.utils";

type MonthlyUsageChartProps = {
  displayType: string;
  lastYearData: MonthlyData[];
  thisYearData: MonthlyData[];
};

export const MonthlyUsageChart: React.FC<MonthlyUsageChartProps> = ({
  displayType,
  lastYearData,
  thisYearData,
}) => {
  const { selectedMonthIndex, setSelectedMonthIndex } = useMonthlyUsageChart();
  const maxYValue = getMaxYValue({
    thisYearData,
    lastYearData,
    displayType,
  });

  const thisYear = new Date().getFullYear();
  const lastYear = thisYear - 1;

  const groupedBarChartConfig = generateGroupedBarChartConfig({
    lastYearData,
    thisYearData,
    lastYear,
    thisYear,
    displayType,
  });

  return (
    <GroupedBarChart
      componentTitle={groupedBarChartConfig.chartTitle}
      errorBoundaryMsg={ERROR_BOUNDARY_MESSAGES.chartjs}
      className="chart__container"
      chartConfig={groupedBarChartConfig}
      maxYValue={maxYValue}
      onClickMutation={setSelectedMonthIndex}
      selectedDataIndex={selectedMonthIndex}
    />
  );
};
